import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({ name: 'encodeUrl' })
export class EncodeUrlPipe implements PipeTransform {
	constructor() {}

	transform(url: string) {
		return encodeURIComponent(url);
	}
}
